import { render, staticRenderFns } from "./aiCustomPageDataView.vue?vue&type=template&id=9f7f9430&scoped=true&"
import script from "./aiCustomPageDataView.vue?vue&type=script&lang=js&"
export * from "./aiCustomPageDataView.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPageDataView.vue?vue&type=style&index=0&id=9f7f9430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7f9430",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f7f9430')) {
      api.createRecord('9f7f9430', component.options)
    } else {
      api.reload('9f7f9430', component.options)
    }
    module.hot.accept("./aiCustomPageDataView.vue?vue&type=template&id=9f7f9430&scoped=true&", function () {
      api.rerender('9f7f9430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageDataView.vue"
export default component.exports